import React from 'react';
import PropTypes from 'prop-types';

class CustomizationTypeSelect extends React.Component {
    constructor() {
        super();
        this.setActiveType = this.setActiveType.bind(this);
    }

    renderType(type) {
        const classes = ['menu__item'];
        if (this.props.activeType === type.key) {
            classes.push('menu__item--active');
        }
        return (
            <li
                className={classes.join(' ')}
                onClick={() => this.props.onChange(type.key)}
                key={type.key}
            >
                <span className="label">{type.value}</span>
            </li>
        );
    }

    setActiveType(activeType) {
        this.props.onChange(activeType);
    }

    render() {
        return (
            <div className="submenu__row">
                <ul className="menu">{this.props.types.map(type => this.renderType(type))}</ul>
            </div>
        );
    }
}

CustomizationTypeSelect.propTypes = {
    onChange: PropTypes.func.isRequired,
    activeType: PropTypes.string,
    types: PropTypes.array,
};

CustomizationTypeSelect.defaultProps = {
    activeType: null,
    types: [],
};

export default CustomizationTypeSelect;
